const market = {
  dsbz: "대기 중인 코인",
  kpsj: "개장 카운트다운 / 개장 시간",
  ykp: "이미 개장됨",
  kpdjs: "개장 카운트다운",
  worning: "최종 거래 단가가 아니며, 참고용으로만 제공됩니다",
  swapTab_1: "USDT 기반 계약",
  swapTab_2: "코인 기반 계약",
  searchCoin: "찾고자 하는 코인 검색",
  risk: "위험 경고",
  addSelfCode: "자체 코드 추가",
  pair: "코인 페어",
  latestPrice: "최신 가격",
  changeHour: "변동폭",
  highHour: "24시간 최고",
  lowHour: "24시간 최저",
  priceTrend: "가격 추세 (3일)",
  volumeHour: "24시간 거래량",
  noSearch: "검색된 코인이 없습니다",
  noAdd: "자체 코드가 아직 추가되지 않았습니다",
  noYet: "해당 코인이 아직 상장되지 않았습니다",
  noBi: "해당 코인이 아직 온라인 상태가 아닙니다",
  wan: "만",
  qian: "천",
  yi: "억",
  yxhy: "영속 계약",
  wghy: "그리드 계약",
  cxjy: "혁신 구역의 코인은 기술과 시장 등에서 일정한 성과를 보유하지만, 가격 변동이 크고, 리스크도 상대적으로 높습니다. 관련 자료를 주의 깊게 검토하고 자신의 범위 내에서 참여 여부를 결정하는 것이 좋습니다.",
  qljy: "잠재력 거래 구역은 아직 시장 개발 초기 단계에 있으며, BiKing은 그 가치 공감 및 시장 유통 상황에 대해 어떠한 보증도 할 수 없습니다. 프로젝트 정보를 주의 깊게 살펴보고 자신이 수용할 수 있는 범위 내에서 신중하게 투자하세요.",
  qljyDao:
    "DAO 거래 구역은 아직 시장 개발 초기 단계에 있으며, BiKing은 그 가치 공감 및 시장 유통 상황에 대해 어떠한 보증도 할 수 없습니다. 프로젝트 정보를 주의 깊게 살펴보고 자신이 수용할 수 있는 범위 내에서 신중하게 투자하세요.",
  default:
    "거래 구역은 아직 시장 개발 초기 단계에 있으며, BiKing은 그 가치 공감 및 시장 유통 상황에 대해 어떠한 보증도 할 수 없습니다. 프로젝트 정보를 주의 깊게 살펴보고 자신이 수용할 수 있는 범위 내에서 신중하게 투자하세요.",
  storage:
    "저장 거래 구역은 아직 시장 개발 초기 단계에 있으며, BiKing은 그 가치 공감 및 시장 유통 상황에 대해 어떠한 보증도 할 수 없습니다. 프로젝트 정보를 주의 깊게 살펴보고 자신이 수용할 수 있는 범위 내에서 신중하게 투자하세요",
  dlt: "저유동성 구역의 디지털 자산 시장 유통성이 낮으며, 상폐의 위험이 있습니다. 투자를 고려하기 전에 신중하게 고려하는 것이 좋습니다.",
  defi: "DEFI 거래 구역은 아직 시장 개발 초기 단계에 있으며, BiKing은 그 가치 공감 및 시장 유통 상황에 대해 어떠한 보증도 할 수 없습니다. 프로젝트 정보를 주의 깊게 살펴보고 자신이 수용할 수 있는 범위 내에서 신중하게 투자하세요.",
  nft: "NFT 거래 구역은 아직 시장 개발 초기 단계에 있으며, BiKing은 그 가치 공감 및 시장 유통 상황에 대해 어떠한 보증도 할 수 없습니다. 프로젝트 정보를 주의 깊게 살펴보고 자신이 수용할 수 있는 범위 내에서 신중하게 투자하세요.",

  hz: "영속",
  yx: "연구",
  yjyzx: "연구원 선정 프로젝트",
  zx: "자체",
  bb: "현금",
  hy: "계약",
  zfb: "상승폭 랭킹",
  xbb: "신코인 랭킹",
  bd: "코인 페어",
  zxj: "최신 가격",
  zdf24: "24시간 변동폭",
  high24: "24시간 최고",
  low24: "24시간 최저",
  turnover24: "24시간 거래량",
  zd24: "24시간 변동",
  zjrzd: "가격/일 변동",
  scgl: "시장 개요",
  jysj: "거래 데이터",
  fyje: "리베이트 금액",
  不允许任何用户通过多: "사용자는 여러 계정을 통해 자체 초대할 수 없습니다. 일단 확인되면 모든 리베이트는 취소됩니다. 초대된 계정의 처리 수수료는 환불됩니다",
  交易人数: "트레이더 수",
  使用你的推荐链接:"추천 링크 또는 추천 코드를 사용하여 등록한 사용자는 초대 대상자로 간주됩니다. 사용자가 등록 시 추천 코드를 입력하지 않으면 초대 관계가 설정되지 않습니다.",
  保留对活动的最终解释权:" 질문이 있으시면 고객 서비스에 문의하십시오. ",
  合约交易返佣: "고가치 계약 거래에 대해 리베이트 받기",
  合约手续费: "계약 처리 수수료 ",
  合约返佣: "계약 누적 수수료 리베이트",
  好友返佣比例: "친구의 리베이트 비율",
  我的返佣比例: "나의 리베이트 비율",
  推荐人数: "추천 횟수",
  推荐好友: "친구 추천",
  推荐总览: "추천 개요 ",
  推荐: "추천",
  推荐码: "추천 코드",
  推荐记录: "추천 기록",
  推荐链接:'추천링크',
  一键分享:'클릭 한 번으로 공유',
  是否交易: "거래 여부",
  注册时间: "등록 시간(UTC+8)",
  用户邀请朋友无上限: "사용자가 친구를 초대하는 데에는 제한이 없습니다, 초대받은 사람은 계약 거래에 대한 회계 수수료만 받습니다.",
  由于市场环境的改变:"시장 환경 변화, 사기 위험 존재 및 기타 사유로 인해 바이킹은 언제든지 리베이트 규칙을 조정할 수 있는 최종 권리를 보유합니다. ",
  被邀请人产生的真实交易手续费:"초대받은 사람이 발생하는 실제 거래 수수료에 대해 초대자는 거래 수수료에 해당하는 수수료를 받을 수 있으며, 이는 다음날 초대자의 계좌로 반환됩니다. 구체적인 입금 시간은 매일 4시 이후입니다.. ",
  被邀请人只有进行合约:" ",
  请输入账户UID: "계정 UID를 입력하세요",
  账户UID: "계정 UID",
  返佣活动规则说明: "리베이트 활동 규칙 설명:",
  返佣记录: "리베이트 기록",
  ms: "거",
  mf: "래",
};

export { market };



// WEBPACK FOOTER //
// ./src/i18n/lang/market/kr.js